// @flow

import {
    GET_COMMENTS,
    GET_COMMENTS_FAIL,
    GET_COMMENTS_SUCCESS,
    SELECT_COMMENT,
    START_DRAWING_COMMENT,
    FINISH_DRAWING_COMMENT,
    CANCEL_DRAWING_COMMENT,
} from './../types/comments';

export const getComments = (axiosInstance: Object) => ({
    type: GET_COMMENTS,
    axiosInstance: axiosInstance,
})

export const getCommentsSuccess = (comments) => ({
    type: GET_COMMENTS_SUCCESS,
    comments,
})

export const getCommentsFail = () => ({
    type: GET_COMMENTS_FAIL,
})

export const selectComment = (comment) => ({
    type: SELECT_COMMENT,
    comment,
})

export const startDrawingCommentGeometry = (comment) => ({
    type: START_DRAWING_COMMENT,
    comment,
});

export const finishDrawingCommentGeometry = () => ({
    type: FINISH_DRAWING_COMMENT
});

export const cancelDrawingCommentGeometry = () => ({
    type: CANCEL_DRAWING_COMMENT
});


// WEBPACK FOOTER //
// ./src/actions/comments.jsx